import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAllTasks, selectTasks } from '~/reducers/tasksSlice';
import { selectDate } from '~/reducers/selectedDateSlice';
import { Task } from '~/data-classes';
import { ApiTask } from '~/api/types';

export const useGetAllTasks = () => {
    const selectedTasks = useSelector(selectTasks) as ApiTask[];
    const selectedDate = useSelector(selectDate) as string;
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllTasks({ routeDate: selectedDate }));
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [selectedDate]);

    const allTasks = useMemo(
        () =>
            Object.fromEntries(
                Object.entries(selectedTasks).map(([key, task]) => [
                    key,
                    new Task(task)
                ])
            ),
        [selectedTasks]
    );
    const tasks = Object.values(allTasks);
    const numberOfTasks = tasks.length;
    const numberOfUnassignedTasks = tasks.filter(
        ({ isUnassigned }) => isUnassigned
    ).length;

    return {
        allTasks,
        numberOfTasks,
        numberOfUnassignedTasks
    };
};
